<div class="main-item">
  <ion-row scrollX="true" class="scroll-items">
    <ion-col *ngFor="let item of message | slice: 0: 5; let i = index;">
      
      <div class="container">
        <div class="confirm">
          <p> Confirm? </p>
        </div>
        <div class="suggestion">
          <div class="loading" *ngIf="isLoading && !isLoaded">
          </div>
          <div class="select" *ngIf="isLoaded" (click)="setSuggestion(item)">
            <ion-icon name="checkmark-outline"></ion-icon>
          </div>
          <div class="body" *ngIf="isLoaded">
            <ion-label class="item-value" *ngIf="key !== 'price'">{{ item | truncate:25 }}</ion-label>
            <ion-label class="item-value" *ngIf="key === 'price'">{{ item | currency:'USD':'symbol':'1.0-0' | truncate:25 }}</ion-label>
    
          </div>
    
          <div class="cancel" *ngIf="isLoading || isLoaded" (click)="cancelSuggestion(item,i)">
            <ion-icon name="close-outline"></ion-icon>
          </div>
        </div>
      </div>
    </ion-col>
  </ion-row>
</div>